import React from 'react';
import Icon from '../../../components/AppIcon';

const RemediationStatisticsCard = ({ statistics }) => {
  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return 'K0.00';
    return `K${amount?.toFixed(2)?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  };

  const stats = [
    {
      label: 'Total Violations',
      value: statistics?.totalViolations || 0,
      icon: 'AlertTriangle',
      color: 'var(--color-muted-foreground)',
      bgColor: 'bg-muted'
    },
    {
      label: 'Critical',
      value: statistics?.criticalViolations || 0,
      icon: 'AlertCircle',
      color: 'var(--color-error)',
      bgColor: 'bg-error/10'
    },
    {
      label: 'Pending',
      value: statistics?.pendingRemediations || 0,
      icon: 'Clock',
      color: 'var(--color-warning)',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'In Progress',
      value: statistics?.inProgressRemediations || 0,
      icon: 'Play',
      color: 'var(--color-info)',
      bgColor: 'bg-info/10'
    },
    {
      label: 'Completed',
      value: statistics?.completedRemediations || 0,
      icon: 'CheckCircle2',
      color: 'var(--color-success)',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Backpay Required',
      value: formatCurrency(statistics?.totalBackpayRequired),
      icon: 'DollarSign',
      color: 'var(--color-warning)',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Backpay Paid',
      value: formatCurrency(statistics?.totalBackpayPaid),
      icon: 'CheckCircle',
      color: 'var(--color-success)',
      bgColor: 'bg-success/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {stats?.map((stat, index) => (
        <div key={index} className={`${stat?.bgColor} rounded-lg p-4`}>
          <div className="flex items-center gap-2 mb-2">
            <Icon name={stat?.icon} size={16} color={stat?.color} />
            <p className="caption text-xs text-muted-foreground">{stat?.label}</p>
          </div>
          <p className="font-heading font-bold text-xl text-foreground">
            {stat?.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default RemediationStatisticsCard;